import { object } from "prop-types";
const UPDATE_ACTIVITY_DETAIL_MSG="updateActivityDetaillMsg";

const initialState = {
    msg:''            //弹窗文案
}
const reducer = function(state = initialState, action) {
    let { type, params } = action;
    switch (type) {
        case UPDATE_ACTIVITY_DETAIL_MSG:return Object.assign({},state,{
            msg:params
        })
        default: return state;
    }
}

export {
    reducer as default,
    initialState as activityDetailInitialState
}
